require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-cut-the-engine-why-should-mdbs-phase-out-support-for.json") })
        }
      }, "path---en-us-update-cut-the-engine-why-should-mdbs-phase-out-support-for");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-cut-the-engine-why-should-mdbs-phase-out-support-for!./.cache/json/en-us-update-cut-the-engine-why-should-mdbs-phase-out-support-for.json
// module id = 652
// module chunks = 231608221292675